var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinalPayoutCardBgOverlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.448909 6.70154L6.12389 0.890625H13.4599L3.21719 9.89754C1.13972 11.4955 -0.936683 8.73536 0.448909 6.70154Z",
    fill: "#FEEBB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7805 22.1005C14.9812 23.6985 12.4897 21.0835 14.0122 18.9045C18.3875 14.1273 21.2443 11.6265 26.608 7.28263C28.7605 5.53936 31.1757 8.73536 29.7915 10.4786L16.7805 22.1005Z",
    fill: "#FEEBB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85985 28.0566C8.3373 29.3641 6.12267 31.6885 3.4928 33.577C1.13976 34.5939 -0.521216 32.5601 0.586098 30.6716C2.24707 29.2188 3.4928 26.4586 6.3995 25.0059C8.75254 23.4079 10.8288 25.8776 9.85985 28.0566Z",
    fill: "#FEEBB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4043 35.4656C41.5464 31.2567 44.6365 28.571 50 23.8437V30.381C46.4477 33.7471 44.4532 35.5823 40.8647 38.6616C38.4944 40.6954 35.6049 38.371 37.4043 35.4656Z",
    fill: "#FEEBB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9891 23.4079C26.2073 33.3491 20.0599 38.8289 9.02937 48.5401C6.3995 49.8476 4.4617 47.2327 6.67633 45.0536L33.6671 20.9383C36.5738 18.9045 38.2348 21.6646 36.9891 23.4079Z",
    fill: "#FEEBB6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalPayoutCardBgOverlay);
export default __webpack_public_path__ + "static/media/final-payout-card-bg-overlay.14d8bc61377731c177a81a1bd2dc8fb6.svg";
export { ForwardRef as ReactComponent };